export default "__VITE_ASSET__904e49f7__"